import { type Liff } from '@line/liff'
import { useWpLayout } from '@pets-ui/useWpLayout/useWpLayout'
import { CardLogin } from '../CardLogin'
import { LoginFlow } from './LoginFlow'

interface LoginPortalProps {
  onBack?: () => void
  liff?: Liff
}

export const LoginPortal = ({ onBack, liff }: LoginPortalProps = {}) => {
  useWpLayout({ footer: false })

  return (
    <CardLogin>
      <LoginFlow liff={liff} onBack={onBack} />
    </CardLogin>
  )
}
